let currentVersion: string | null = null;

async function fetchVersion(): Promise<string | null> {
  try {
    const res = await fetch("/version.txt", { cache: "no-store" });
    if (!res.ok) return null;
    return await res.text();
  } catch {
    return null;
  }
}

export function startVersionWatcher(
  onNewVersion?: (oldV: string | null, newV: string) => void,
  intervalMs = 300000
) {
  let timer: number | undefined;

  const check = async () => {
    const v = (await fetchVersion())?.trim() ?? null;
    if (currentVersion === null && v !== null) {
      currentVersion = v; // first seen
    } else if (v && currentVersion && v !== currentVersion) {
      try {
        onNewVersion?.(currentVersion, v);
      } finally {
        // Default behavior: force reload
        window.location.reload();
        return;
      }
    }
    timer = window.setTimeout(check, intervalMs);
  };

  check();
  return () => {
    if (timer) window.clearTimeout(timer);
  };
}

